//import Header from "./components/Header";
import Header from "./components/Header";
import HeaderTop from "./components/top";
import React from "react";
import "./components/header/Header.css";
import "./scss/general.css";
import Cookies from "universal-cookie";
import { FaBorderAll } from "react-icons/fa";
//import Home from "./components/home";
//import {customRoutes} from "./router";
//import ShowLoader from "./components/Loader";
const cookies = new Cookies();
class App extends React.Component {
constructor(props) {
  super(props);

  // Moblie first
  this.state = {
    isOpen: false,
    isMobile: true,
    loading: true
  };

  this.previousWidth = -1;
}

componentDidMount() {
/*  this.fakeRequest().then(() => {
    const el = document.querySelector(".loader-container");
    if (el && ) {
      el.remove();  // removing the spinner element
      this.setState({ loading: false }); // showing the app
    }
  });*/


  // this simulates an async action, after which the component will render the content
  console.log(cookies.get("LoginID"));
//  cookies.set('phpclass', "../ci2", { path: '/' });       
//  cookies.set('phpclass', "https://d-land.pk/ci2", { path: '/' });   

  if(cookies.get("LoginID"))
  {
    const el = document.querySelector(".loader");
    if (el) {

      el.remove();  // removing the spinner element
      this.setState({ loading: false });
    }
  }
  else
  {
    const el = document.querySelector(".loader-container");
    if (el) {
      el.remove();  // removing the spinner element
    }
    let phpclass=cookies.get("phpclass");
/*    if(phpclass=="https://d-land.pk/ABTAPI") 
      window.location.href = config.Appdirabt+"/login/";
    else if(phpclass=="https://d-land.pk/GPAPI") 
      window.location.href = config.Appdirgp+"/login/";
    else */
      window.location.href = config.Appdir+"/login/";


    //    window.location.href = 'https://www.thekandnsway.pk/kandns/login/';
   
  }
}
updateWidth() {
  const width = window.innerWidth;
  const widthLimit = 576;
  const isMobile = width <= widthLimit;
  const wasMobile = this.previousWidth <= widthLimit;

  if (isMobile !== wasMobile) {
    this.setState({
      isOpen: !isMobile
    });
  }

  this.previousWidth = width;
}


render() {
  let loading  = this.state.loading;
//  console.log(this.state.loading);
  if(!loading) 
  {
    return (
    <>
    <HeaderTop/>
    <Header/>
{/*}    <div style={{border:2,borderColor:"gray"}}>
    <zapier-interfaces-chatbot-embed border="1" borderColor="black" is-popup='true' chatbot-id='cmaza6hpz006x5p2zdh3lamaa'></zapier-interfaces-chatbot-embed>
    </div>
    */}
    <a
      href="https://wa.me/923333087092"
      className="whatsapp_float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fa fa-whatsapp whatsapp-icon"></i>
  </a>
  </>
  ); 
}
else
  return (null);


/*}  if(cookies.get("LoginID"))
{
  return (
      <div >
        <Header/>
      <a
        href="https://wa.me/923333087092"
        className="whatsapp_float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fa fa-whatsapp whatsapp-icon"></i>
      </a>

      </div>
  );
}
else
{
    return(
      <div>{ window.location.href="https://www.thekandnsway.pk/kandns/login/"} </div>
    );
}*/
}
}
export default App;
